export default {"src":"/_next/static/media/userFocus_24.8aac779b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};